import { render, staticRenderFns } from "./VesselMovementTypeList.vue?vue&type=template&id=b0e165ac"
import script from "./VesselMovementTypeList.vue?vue&type=script&lang=js"
export * from "./VesselMovementTypeList.vue?vue&type=script&lang=js"
import style0 from "./VesselMovementTypeList.vue?vue&type=style&index=0&id=b0e165ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports